import React from "react";

const formatValue = (value) => {
	if (value === null || value === undefined) {
		return "—";
	}
	if (typeof value === "object") {
		return JSON.stringify(value, null, 2);
	}
	return String(value);
};

const ChangeDetail = ({ row }) => {
	const oldValues = row?.changes?.old || {};
	const newValues = row?.changes?.new || {};
	const properties = row?.properties || {};
	const keys = [...new Set([...Object.keys(oldValues), ...Object.keys(newValues)])];

	return (
		<div className="space-y-4 p-4 bg-gray-50 rounded text-sm font-sans">
			{row?.message && (
				<div>
					<p className="font-semibold text-gray-700">Summary</p>
					<p>{row.message}</p>
				</div>
			)}

			{keys.length > 0 && (
				<div>
					<p className="font-semibold text-gray-700 mb-2">Field changes</p>
					<div className="overflow-x-auto">
						<table className="min-w-full border border-gray-200 bg-white">
							<thead>
								<tr className="bg-gray-100 text-left">
									<th className="p-2 border-b">Field</th>
									<th className="p-2 border-b">Before</th>
									<th className="p-2 border-b">After</th>
								</tr>
							</thead>
							<tbody>
								{keys.map((key) => (
									<tr key={key}>
										<td className="p-2 border-b font-medium">{key}</td>
										<td className="p-2 border-b whitespace-pre-wrap">{formatValue(oldValues[key])}</td>
										<td className="p-2 border-b whitespace-pre-wrap">{formatValue(newValues[key])}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			)}

			{Object.keys(properties).length > 0 && (
				<div>
					<p className="font-semibold text-gray-700 mb-2">Additional context</p>
					<pre className="bg-white border border-gray-200 rounded p-3 overflow-x-auto text-xs">
						{JSON.stringify(properties, null, 2)}
					</pre>
				</div>
			)}

			<div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-xs text-gray-600">
				<span>Source: {row?.metadata?.source || "api"}</span>
				<span>IP: {row?.metadata?.ip_address || "—"}</span>
				<span>User agent: {row?.metadata?.user_agent || "—"}</span>
			</div>
		</div>
	);
};

export default ChangeDetail;
